import { Account } from "@wingspanhq/wingspan-api-sdk";

import {
  getCurrentSelectableYear,
  getSelectableYears,
  getYearUtcRange
} from "../../shared/utils/selectableYears";

import { PAYSTUBS_FIRST_YEAR } from "./constants";
import { PaystubsYear } from "./paths";

const EMPTY_VALUE = "—";

/** Selectable years for the dashboard switcher, derived from the clock. */
export const getPaystubsYears = (): PaystubsYear[] =>
  getSelectableYears(PAYSTUBS_FIRST_YEAR);

export const getDefaultPaystubsYear = (): PaystubsYear =>
  getCurrentSelectableYear(PAYSTUBS_FIRST_YEAR);

/**
 * The `payDate` filter range (`gte`/`lte`) for a paystubs dashboard year. Used to
 * scope the payee's pay-statement list to the selected calendar year — statements
 * without a `payDate` (e.g. unprocessed drafts) fall outside the range and are
 * excluded, which is the desired behaviour for a payee "paystubs" view.
 *
 * Bounds are UTC (matching the payroll-runs range) so the serialized filter does
 * not shift the year boundary by the viewer's offset.
 */
export const getPaystubsYearRange = (
  year: PaystubsYear
): { gte: Date; lte: Date } => getYearUtcRange(year);

/**
 * The employer (payer) display name shown on the payee's paystubs — the payer
 * account's profile display name, falling back to its legal name.
 */
export const formatPayerName = (account?: Account): string =>
  account?.profile?.displayName ??
  account?.complianceEntity?.legalName ??
  EMPTY_VALUE;
